export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fd1ae91b742ff6906b955b7'
  }
};

export const QUERY = `
  mutation paymentMethodRemoveOne ($filter: AutoFilledFilterRemoveOnepaymentMethodsInput!, $sort: SortRemoveOnepaymentMethodsInput){
      paymentMethodRemoveOne (filter: $filter, sort: $sort){
          recordId
          record {
              _id
              type
              bank{
                  bsb
                  account
                  name
              }
              card{
                  cardNo
                  fzToken
              }
           companies
              direction
          }
      }
  }
    `;
